import { Input, Radio, Space, Checkbox } from "antd";
import React, {useRef} from "react";

export function MultipleChoiceItem (props){
    const {item, index, current, pageSize} = props;
    const {question, options, correctAnswer, reason, isMore} = item;

    return (
        <div className= 'container mt-2 d-flex justify-content-between flex-column multiple-choice'>
            <p style={{fontWeight: 'bold', fontSize: '14px'}}>
                {(current-1) * pageSize + props.index + 1} : {question}
            </p>
            <Checkbox.Group className='d-flex flex-column' style={{width: '100%'}} value={correctAnswer} disabled={true}>
                {options.map((ele, key)=>
                    <Checkbox key={key} value={key} style={{width: '100%', borderRadius: '5px', padding: '10px'}}>
                        {ele}
                    </Checkbox>
                )}
            </Checkbox.Group>


            {isMore ?
                <p style={{fontSize: '14px', paddingTop: '5px'}}>Explaination: {reason}</p>
                :
                null
            }
        </div>
    );
}


export function EditMultipleChoiceItem(props){
    
    const {item, index} = props;
    const {question, options, correctAnswer, reason, url, question_id, page, document_id} = item;

    const temOptionsRef = useRef(options.slice());

    const onChange = (value)=>{
        props.handleAnswerChange({correctAnswer: value});
    }
    const handleTextChange = ({target: {value}}, index)=>{
        temOptionsRef.current[index] = value;
        props.handleAnswerChange({options: temOptionsRef.current});
    }
    const handleQuestionChange = ({target: {value}})=>{
        props.handleAnswerChange({question: value});
    }
    return (
        <>
            <Input defaultValue={question} onChange={handleQuestionChange}/>

            <Checkbox.Group className='d-flex flex-column' style={{width: '100%'}} defaultValue={correctAnswer} onChange={onChange}>
                {options.map((ele, key)=>
                    <Checkbox key={key} value={key} style={{width: '100%', borderRadius: '5px', padding: '10px'}}>
                        <Input style={{width: '100%',}} defaultValue={ele} onChange={(v)=>handleTextChange(v, key)} />
                    </Checkbox>
                )}
            </Checkbox.Group>
            <ImageDisplay imgList={url} isEdit={true} document_id={document_id} question_id={question_id} page={page}/>
        </>
    );
}